import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs/Observable';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { APP_CONFIG } from '../config';
import { TargetSystemModel } from '../model';
import { LogService } from '../services/logging.service';
import { ApigeeDAO } from './apigee.dao';
import { DefaultRetryHandler } from './handlers/retry.handlers';
import { TargetSystemValidator } from './validators';

const CLASS_NAME = 'TargetSystemDao';

@Injectable()
export class TargetSystemDao extends ApigeeDAO {
  constructor(@Inject(APP_CONFIG) appConfig: IAppConfig, http: HttpClient, log: LogService, cookieService: CookieService) {
    super(CLASS_NAME, http, appConfig, appConfig.targetSystemDAO, new DefaultRetryHandler(), new TargetSystemValidator(), log, cookieService);
  }

  public get(): Observable<TargetSystemModel> {
    return this.doGet(this.daoConfig.url);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/daos/target-system.dao.ts